import { Component, AsyncComponent, CreateElement } from 'vue';

import PopoverModal from '@/components/modals/vfm/PopoverModal.vue';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';

export type ComponentProps = { [key: string]: any };
export type ComponentRef = string | Component | AsyncComponent;
export interface PopoverOptions<T extends ComponentRef = ComponentRef> extends ComponentProps {
	popoverProps?: ComponentProps;
	componentProps?: ComponentProps;
	component: T;
}

const create = ({ popoverProps, component, componentProps, ...props }: PopoverOptions) => {
	const { promise, dismiss } = VFMHelper.open({
		type: 'popover',
		slotComponent: {
			render(h: CreateElement) {
				return h(PopoverModal, { props: popoverProps }, [
					h(component, { props: componentProps, on: { dismiss } }),
				]);
			},
		},
		...props,
	});

	return promise;
};

export const PopoverHelper = {
	create,
};
